import axios from "axios";

export default function updateDispatchInstruction(parameters) {
  return new Promise((resolve, reject) => {
    axios
      .post("/distributor/admin/api/v1/shipping-order/update-di", {
        status: parameters.status,
        list: parameters.list,
        shipping_order_uuid: parameters.shipping_order_uuid,
        reason: parameters.reason,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
